module.exports = __webpack_public_path__ + "img/Icon_History_Services.f84d4933.svg";